module.exports = "<div class=\"user-details-component user-certificates\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      CERTIFICATES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"certificates-grid\">\r\n      <div id=\"certificates-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-certificates/user-certificates.html
 ** module id = 627
 ** module chunks = 0
 **/